<template>
    <div class="parent" :class="{ isDisabled: isDisabled }">
        <div class="name">
            <div v-if="isDisabled">{{ item.name }}</div>
            <div v-else>
                <div v-if="isLinkToItemDetail">
                    <router-link target="_blank" :to="link">{{ item.name }}</router-link>
                </div>
                <div v-else>
                    <a @click="$emit('clicked');">{{ item.name }}</a>
                </div>
            </div>
            <div v-if="isObsolete" class="obsolete"><span>obsolete</span></div>
            <div v-if="isCanceled" class="obsolete"><span>canceled</span></div>
        </div>
        <div class="ean">EAN: {{ item.clientEanRef }}</div>
        <div class="sap">SAP: {{ item.clientSapRef }}</div>
        <div class="prices" v-if="isShowPriceDetails">
            Prices: <AllPricesInfo style="display: inline-block" :item="item" :forecast-windows="forecastWindows" />
        </div>
    </div>
</template>
<script>
import AllPricesInfo from "@/components/forecasts/elements/AllPricesInfo";
import ItemValidator from "@/components/forecasts/validation/itemValidator";
export default {
    components: { AllPricesInfo },
    props: {
        item: {
            type: Object,
            required: true
        },
        isLinkToItemDetail: {
            type: Boolean,
            required: false,
            default: true
        },
        isShowPriceDetails: {
            type: Boolean,
            required: false,
            default: false
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false
        },
        forecastWindows: {
            type: Array,
            required: false
        }
    },
    computed: {
        isCanceled() {
            return ItemValidator.isCancelled(this.item);
        },
        isObsolete() {
            return ItemValidator.isObsolete(this.item);
        },
        link() {
            let query = this.forecast ? `?selectedForecast=${this.forecast.id}` : "";
            return `/${this.item.type}/${this.item.id}${query}`;
        }
    }
};
</script>
<style scoped lang="scss">
@import "../css/forecasts.scss";
.parent {
    div {
        text-align: left;
    }
}
.name {
    a {
        color: #d7a57e;
        display: block;
        font-size: 18px;
        font-weight: bold;
        text-decoration: none;
    }
    div {
        color: #d7a57e;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 5px;
        display: inline-block;
    }
}
.isDisabled .name {
    color: grey;
}
.obsolete {
    margin-left: 20px;
    span {
        font-size: 0.8em;
        color: #fff;
        background-color: #90908f;
        border-radius: 50px 50px 50px 50px;
        padding: 3px;
        width: 80px;
        display: inline-block;
        text-align: center;
    }
}
.ean {
    font-size: 16px;
}
.sap {
    font-size: 16px;
}
.prices {
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// ItemDescription.vue?505f18e3